// Lightweight analytics facade.
// - Safely calls GA4 (window.gtag) and Meta Pixel (window.fbq) if they're loaded.
// - No-ops otherwise (logs in dev). When the user adds GA4/Pixel snippets to
//   public/index.html, every tracked event will start firing automatically.

const FB_EVENT_MAP = {
  care_request_submitted: "Lead",
  caregiver_application_submitted: "SubmitApplication",
  consultation_booked: "Schedule",
  contact_form_submitted: "Contact",
  referral_submitted: "Lead",
  phone_clicked: "Contact",
};

export function track(eventName, params = {}) {
  try {
    if (typeof window === "undefined") return;
    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, params);
    }
    if (typeof window.fbq === "function") {
      const mapped = FB_EVENT_MAP[eventName];
      if (mapped) window.fbq("track", mapped, params);
    }
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.info("[analytics]", eventName, params);
    }
  } catch {
    /* never block UX */
  }
}

export function trackPhoneClick(location) {
  return () => track("phone_clicked", { location });
}
